import { useEffect, useRef, useState } from "react";
import { Eraser } from "lucide-react";

export function SignaturePad({ onChange }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [hasInk, setHasInk] = useState(false);

  useEffect(() => {
    const c = canvasRef.current;
    const ctx = c.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, c.width, c.height);
    ctx.strokeStyle = "#111827";
    ctx.lineWidth = 2.5;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
  }, []);

  const pos = (e) => {
    const c = canvasRef.current;
    const r = c.getBoundingClientRect();
    return { x: (e.clientX - r.left) * (c.width / r.width), y: (e.clientY - r.top) * (c.height / r.height) };
  };

  const down = (e) => {
    e.preventDefault();
    drawing.current = true;
    canvasRef.current.setPointerCapture?.(e.pointerId);
    const ctx = canvasRef.current.getContext("2d");
    const p = pos(e);
    ctx.beginPath();
    ctx.moveTo(p.x, p.y);
  };

  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext("2d");
    const p = pos(e);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
  };

  const up = () => {
    if (!drawing.current) return;
    drawing.current = false;
    setHasInk(true);
    onChange(canvasRef.current.toDataURL("image/png"));
  };

  const clear = () => {
    const c = canvasRef.current;
    const ctx = c.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, c.width, c.height);
    setHasInk(false);
    onChange(null);
  };

  return (
    <div>
      <span className="block text-xs text-white/50 mb-1.5">手書きサイン（枠内に署名してください）</span>
      <div className="rounded-lg border border-white/15 overflow-hidden bg-white">
        <canvas
          ref={canvasRef}
          width={640}
          height={200}
          className="w-full h-40 touch-none cursor-crosshair"
          data-testid="signature-canvas"
          onPointerDown={down}
          onPointerMove={move}
          onPointerUp={up}
          onPointerLeave={up}
        />
      </div>
      <div className="mt-2 flex items-center justify-between">
        <span className="text-xs text-white/30" data-testid="signature-state">{hasInk ? "署名済み" : "未署名"}</span>
        <button
          type="button"
          onClick={clear}
          data-testid="signature-clear"
          className="inline-flex items-center gap-1.5 rounded-lg border border-white/20 px-3 py-1.5 text-xs text-white/70 hover:text-gold hover:border-gold/40 transition-colors"
        >
          <Eraser size={13} /> 書き直す
        </button>
      </div>
    </div>
  );
}
